export const baseUrl = 'https://cdipsc-api.multimpressoes.com.br/api'
export const apiUrl = baseUrl

export const adminRoot = '/app'
